import {
  AccountsReportSearchParamsModel,
  GeneralPrintResponseModel,
  IncomeStatementReportSearchParamsModel,
  IncomeStatementReportSearchParamsStringModel,
  ResponseBaseModel, TrialBalanceReportSearchParamsModel,
} from "../models";
import AlYusrAxiosApiInstance, {
  AxiosSearchParams,
} from "../axios/alYusrAxiosApiInstance";
import { AlYuserApiUrls } from "../configuration";
import { formatToIsoString } from "../utils";
//#region get
export const searchReportGeneralLedger = async (
  request: AccountsReportSearchParamsModel
): Promise<ResponseBaseModel<GeneralPrintResponseModel>> => {
  return await AlYusrAxiosApiInstance.get(
    AlYuserApiUrls.acTransactionReportController.searchReportGeneralLedger,
    {
      params: AxiosSearchParams(request, "searchParmeter"),
    }
  );
};
export const searchReportIncomeStatement = async (
  request: IncomeStatementReportSearchParamsModel
): Promise<ResponseBaseModel<GeneralPrintResponseModel>> => {
  let req: IncomeStatementReportSearchParamsStringModel = {
    ...request,
    fromDate: formatToIsoString(request?.fromDate ?? ""),
    toDate: formatToIsoString(request?.toDate ?? ""),
  };
  return await AlYusrAxiosApiInstance.get(
    AlYuserApiUrls.acTransactionReportController.searchReportIncomeStatement,
    {
      params: AxiosSearchParams(req, "searchParmeter"),
    }
  );
};
export const searchTrialBalanceReport = async (
    request: TrialBalanceReportSearchParamsModel
): Promise<ResponseBaseModel<GeneralPrintResponseModel>> => {
  let req: IncomeStatementReportSearchParamsStringModel = {
    ...request,
    fromDate: formatToIsoString(request?.fromDate ?? ""),
    toDate: formatToIsoString(request?.toDate ?? ""),
  };
  return await AlYusrAxiosApiInstance.get(
      AlYuserApiUrls.acTransactionReportController.searchReportTrialBalance,
      {
        params: AxiosSearchParams(req, "searchParmeter"),
      }
  );
};
export const searchReportBalanceSheet = async (
  request: IncomeStatementReportSearchParamsModel
): Promise<ResponseBaseModel<GeneralPrintResponseModel>> => {
  let req: IncomeStatementReportSearchParamsStringModel = {
    ...request,
    fromDate: formatToIsoString(request?.fromDate ?? ""),
    toDate: formatToIsoString(request?.toDate ?? ""),
  };
  console.log(req, "searchReportBalanceSheet");

  return await AlYusrAxiosApiInstance.get(
    AlYuserApiUrls.acTransactionReportController.searchReportBalanceSheet,
    {
      params: AxiosSearchParams(req, "searchParmeter"),
    }
  );
};
//#endregion
